import { render, staticRenderFns } from "./DBOuseLandTotalChart.vue?vue&type=template&id=6964a224&scoped=true"
import script from "./DBOuseLandTotalChart.vue?vue&type=script&lang=js"
export * from "./DBOuseLandTotalChart.vue?vue&type=script&lang=js"
import style0 from "./DBOuseLandTotalChart.vue?vue&type=style&index=0&id=6964a224&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6964a224",
  null
  
)

export default component.exports